import React from "react";
import insta from "../images/insta.svg";
export default function Footer() {
  return (
    <div className="container mt-5 mb-3">
      <div className="row-col-1">
        <center className="col  footer">
          <h4>Director</h4>
          <h5 className="p-1">
            <img src={insta} width="30px" alt="insta" />
            {"  "}
            <a
              href="https://www.instagram.com/_av_allwin_/?utm_medium=copy_link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              Alwin
            </a>
          </h5>{" "}
          ,{" "}
          <h5 className="p-1">
            <a
              href="https://www.instagram.com/_.d24__/?utm_medium=copy_link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Diwakar
            </a>
          </h5>
        </center>
      </div>
    </div>
  );
}
